import Index from './index.vue'
import List from './components/List.vue'

export default [
  {
    path: 'wallet',
    name: 'wallet',
    component: Index,
    title: 'Wallet',
    redirect: { name: 'wallet-list' },
    children: [
      {
        path: 'list',
        name: 'wallet-list',
        component: List,
      },
    ],
  },
]
